
<style>
.inbound-steps .vview-icons-ios-checkmark-empty::before {
	content: "\F171";
}
</style>

<template>
	<vSteps v-if="getCurIndex>-1" :current="getCurIndex" class="bg-fff padding-20 inbound-steps">
		<vStep v-for="(val,key) of progressStatus" :title="val.name" :key="key"></vStep>
	</vSteps>
</template>

<script>
export default {
	props: ['status', 'progressStatus'],
	computed: {
		getCurIndex() {
			return this.progressStatus.findIndex((item) => {
				return item.value == this.status
			})
		},
		// progressStatus() {
		// 	const arr = [
        //         {
        //             name: this.$t('fbb.inbound.draft',{defaultValue:'草稿'}),
        //             value: '0',
        //         },
        //         {
        //             name: this.$t('fbb.inbound.check_pending',{defaultValue:'待审核'}),
        //             value: '5',
        //         },
        //         {
        //             name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '待收货' }),
        //             value: '30',
        //         },
        //         {
        //             name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货中' }),
        //             value: '10',
        //         },
        //         {
        //             name: this.$tc('fbb.sales.sales_status', 2, { defaultValue: '收货完成' }),
        //             value: '70',
        //         }]
		// 	return arr
		// }
	}
}
</script>
